import React from "react";
import nataliaImg from "./assets/img/team/natalia.jpg";
import karolinaImg from "./assets/img/team/karolina.jpeg";
import monikaImg from "./assets/img/team/monika.jpg";
import "./assets/style/AboutUs.css";

function AboutUs() {
  return (
    <section id="about-us" className="about-us section-bg">
      <div className="container-fluid" data-aos="fade-up">
        <div className="section-title">
          <h2>O nas</h2>
        </div>

        {/* Full-width introductory section */}
        <div className="row">
          <div className="col-12">
            <div className="intro-content">
              <p>
                Witaj w natchnieniu, miejscu gdzie pasja spotyka się z
                profesjonalizmem, a Ty możesz rozwijać się w swoim tempie,
                czerpiąc radość z każdej chwili spędzonej na macie. Naszym celem
                jest ciągły rozwój i doskonalenie, aby zapewnić Ci jak najlepsze
                doświadczenie i wsparcie na Twojej drodze do zdrowia.
              </p>
              <p>
                Zajęcia prowadzone są przez wyszkolonych instruktorów, którzy
                inspirują i pomagają odkrywać nowe możliwości ciała i umysłu.
                Dbamy o to, aby każdy trening był wyjątkowy, dopasowany do
                Twoich potrzeb i celów.
              </p>
              <p>
                Zajęcia odbywają się w małych grupach, ponieważ zależy nam na
                indywidualnym podejściu do każdego. Rozumiemy, że początek z
                nowym miejscem, ludźmi i może aktywnością bywa wyzwaniem,
                dlatego dokładamy wszelkich starań, abyś czuła się tutaj
                swobodnie i pewnie.
              </p>
              <p>Do zobaczenia na macie!</p>
            </div>
          </div>
        </div>

        {/* Team Member 1 - Natalia (Text Left, Image Right) */}
        <div className="row team-member" data-aos="fade-up">
          <div className="col-lg-6 d-flex flex-column justify-content-center order-2 order-lg-1">
            <div className="team-content">
              <h3>Natalia Kotłowska</h3>
              <p>
                Założycielka studia Natchnienie. Od najmłodszych lat związana ze sportem. 
                Absolwentka Akademii Wychowania Fizycznego i Sportu w Gdańsku, gdzie uzyskała 
                tytuł magistra wychowania fizycznego. Nauczycielka jogi (RYT 250 h), instruktorka 
                pilatesu na matach, fitnessu, spinningu, pływania, aerobiku sportowego i stretchingu. 
                Na co dzień prowadzi również zajęcia na Gdańskim Uniwersytecie Medycznym.
              </p>
              <p>
                Nieustannie poszerza swoje kwalifikacje, wierząc w holistyczne podejście do ruchu 
                i ciała. Czerpie z różnych metod i szkół, łącząc elementy treningu funkcjonalnego, 
                jogi, pilatesu i technik oddechowych, aby wspierać ciało w harmonijnym, świadomym ruchu.
              </p>
              <p>
                Pełna energii, otwarta i zaangażowana. Z pasją rozwija zarówno siebie, jak i swoich 
                podopiecznych. Dla niej ruch to nie tylko aktywność fizyczna, ale sposób na życie.
              </p>
            </div>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-1 order-lg-2"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <img src={nataliaImg} className="team-img" alt="Natalia Kotłowska - założycielka i instruktorka jogi, pilatesu i fitnessu w Natchnienie Studio Gdańsk" />
          </div>
        </div>

        {/* Team Member 2 - Ola (Image Left, Text Right) */}
        <div className="row team-member" data-aos="fade-up">
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-1"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <img src={karolinaImg} className="team-img" alt="Karolina - instruktorka jogi RYT 500, Vinyasa i joga restoratywna w Natchnienie Studio Gdańsk" />
          </div>
          <div className="col-lg-6 d-flex flex-column justify-content-center order-2">
            <div className="team-content">
              <h3>Karolina Kochel</h3>
              <p>
                Nauczycielka jogi z certyfikacją RYT 500, nieustannie rozwijająca swoją praktykę poprzez
                szkolenia, warsztaty i własne doświadczenie. Swoją drogę buduje w oparciu o uważność,
                bezpieczeństwo i indywidualne podejście do każdego uczestnika.
              </p>
              <p>
                Prowadzi głównie jogę dynamiczną – Vinyasę, łącząc płynny ruch z oddechem, siłę ze
                stabilnością i świadomą pracę z ciałem. Równolegle pracuje z formami regenerującymi,
                takimi jak joga restoratywna i joga nidra.
              </p>
              <p>
                Jogę postrzega jako narzędzie budowania równowagi, wewnętrznego spokoju i harmonii
                między ciałem a umysłem.
              </p>
            </div>
          </div>
        </div>

        {/* Team Member 3 - Monika (Text Left, Image Right) */}
        <div className="row team-member" data-aos="fade-up">
          <div className="col-lg-6 d-flex flex-column justify-content-center order-2 order-lg-1">
            <div className="team-content">
              <h3>Monika Richert</h3>
              <p>
                Instruktorka fitness i pilatesu z ponad siedmioletnim doświadczeniem w pracy z różnymi 
                grupami i poziomami zaawansowania. Magister wychowania fizycznego, absolwentka Akademii 
                Wychowania Fizycznego i Sportu w Gdańsku, gdzie ukończyła specjalizację z zakresu 
                fitnessu – nowoczesnych form gimnastyki, a także kurs instruktora przygotowania motorycznego.
              </p>
              <p>
                Regularnie poszerza swoją wiedzę, uczestnicząc w szkoleniach z zakresu treningu 
                personalnego, zdrowego kręgosłupa czy pilatesu. Dzięki temu prowadzi zajęcia bezpieczne, 
                skuteczne i dopasowane do potrzeb uczestników.
              </p>
              <p>
                W studiu Natchnienie prowadzi zajęcia o różnym charakterze od wzmacniających i siłowych, 
                po prozdrowotne i mobilizujące. W pracy stawia na świadomy ruch, technikę i zrozumienie 
                ciała, a jej zajęcia łączą energię, precyzję i pasję do aktywności.
              </p>
            </div>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-1 order-lg-2"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <img src={monikaImg} className="team-img" alt="Monika Richert - instruktorka fitness i pilatesu w Natchnienie Studio Gdańsk" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
